<h1 mat-dialog-title>{{ config?.title || 'Are you sure?'  }}</h1>

<div mat-dialog-content class="confirmation-dialog-content">
  <p>{{ config?.content || 'Are you sure you want to continue? This cannot be undone.' }}</p>
</div>

<div mat-dialog-actions>
  <div class="d-flex justify-content-end w-100">
    <button
      mat-button
      (click)="dialogRef.close(false)">No</button>

    <button
      mat-flat-button
      (click)="dialogRef.close(true)"
      color="primary">Yes</button>
  </div>
</div>
